import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  VStack,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { walletTopup, subanchorWalletTopup } from "../services/Wallet/walletTopup";
import { useParams } from "react-router-dom";

const WalletTopup = ({ onTopupSuccess, walletId, anchorType, dsaId }) => {
  const { id } = useParams();
  const isSubanchor = anchorType === "sub_anchor";

  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [transactionNo, setTransactionNo] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const handleTopup = async () => {
    if (!amount || !paymentMode || !transactionNo) {
      toast({
        title: "Validation Error",
        description: "Amount, Payment Mode, and Transaction ID are required.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const payload = isSubanchor
      ? {
          amount: parseFloat(amount),
          amount_type: "topup",
          transaction_type: "credit",
          description: description || undefined,
          payment_mode: paymentMode,
          transaction_no: transactionNo,
        }
      : {
          amount: parseFloat(amount),
          amount_type: "topup",
          description,
          transaction_no: transactionNo,
          payment_mode: paymentMode,
          transaction_type: "credit",
          anchor: id,
          dsa: dsaId,
        };

    setLoading(true);
    try {
      if (isSubanchor && id) {
        await subanchorWalletTopup(id, walletId, payload);
      } else {
        await walletTopup(walletId, payload);
      }
      toast({
        title: "Success",
        description: "Wallet topped up successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      if (onTopupSuccess) onTopupSuccess();
      setAmount("");
      setPaymentMode("");
      setTransactionNo("");
      setDescription("");
    } catch (err) {
      toast({
        title: "Top-up Failed",
        description: err.message || "Something went wrong.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <p className="font-semibold text-[20px] my-2">Wallet Top-up</p>
      <Box bgColor={"white"} borderRadius="md" maxW="400px" my={4} p={4}>
        <VStack spacing={6} align="flex-start">
          <FormControl isRequired>
            <FormLabel fontSize="sm">Top-up Amount</FormLabel>
            <Input
              placeholder="e.g. ₹1500"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              type="number"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel fontSize="sm">Transaction ID</FormLabel>
            <Input
              placeholder="Transaction ID"
              value={transactionNo}
              onChange={(e) => setTransactionNo(e.target.value)}
              type="text"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel fontSize="sm">Payment Mode</FormLabel>
            <Select
              placeholder="Select payment mode"
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
            >
              <option value="UPI">UPI</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Credit Card">Credit Card</option>
              <option value="Debit Card">Debit Card</option>
              <option value="Commission Payout">Commission Payout</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel fontSize="sm">Description</FormLabel>
            <Textarea
              placeholder="Add any comment (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormControl>

          <div className="flex gap-4 justify-center items-center">
            <Button
              bgColor={"#233B85"}
              color={"white"}
              onClick={handleTopup}
              isDisabled={loading}
            >
              {loading ? <Spinner size="sm" /> : "Add Money"}
            </Button>
            <Button
              variant={"outline"}
              onClick={() => {
                setAmount("");
                setTransactionNo("");
                setPaymentMode("");
                setDescription("");
              }}
              isDisabled={loading}
            >
              Cancel
            </Button>
          </div>
        </VStack>
      </Box>
    </>
  );
};

export default WalletTopup;
